import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { Component,  ViewChild  } from '@angular/core';
import "devextreme/ui/html_editor/converters/markdown";
import { DxDataGridComponent } from 'devextreme-angular';
import {environment} from '../../../environments/environment'
import {ListOfData,ListOfUserData,state} from "../datasource.models";
import {DatasourceService} from "../datasource.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-datasource-list',
  templateUrl: './datasource-list.component.html',
  styleUrls: ['./datasource-list.component.css']
})
export class DatasourceListComponent {   
  PageSize:string="";
  brokerName: string; 
  brokerToken:string;
    numberofLicenses: number;
    licenseStartdate: string;
    licenceEnddate: string;
    brokersStreet: string;
    number: string;
    box: string;
    zipcode: number;
    location: string;
    cbfanr:string;
    PopupTittle:string;
    id_brokerToken:string;
    fulladdress:string;
    version:string;
    oldversion:string;
    newversion:string;
    selectedstate:number=1;
    statelist=[{id:1,"name":"Approved"},{id:2,"name":"Unapproved"},{id:3,"name":"Blocked"}]
    usernameval:string;
    macaddressval:string;
    useractionval:boolean;
    usermacid:number;
    headerLabel:string;
    configMode:boolean;
headerflag:boolean;
username:string;
  public listOfData: ListOfData[];
  public listOfUserData: ListOfUserData[];
  //public liststate:state[];
  public inputSaveData={
    brokerName: "",
    brokerToken:"",
      numberofLicenses: 0,
      licenseStartdate: "",
      licenceEnddate: "",
      brokersStreet: "",
      number: "",
      box: "",
      zipcode: 0,
      location: "",
      cbfanr:"",
      userId:"",
      version:"",
      configMode:false

  };
  public input_getdata= {
    BrokerToken: "",
    UserId: ""
};
public input_updateversion= {
  token: "",
  oldversion: "",
  newversion:""
};
public input_updateuser= {
  id: 0,
  action: false,
  state:0
};

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  onCellPrepared(e) {   
 
    if(e.rowType === "data" && (e.column.dataField === "edit" ) ) {
      e.cellElement.style.color = "blue";     
      e.cellElement.style.cursor= "pointer" ; 
      e.watch(function() {
          return e.data.view;
      }, function() {
        e.cellElement.style.color = "blue";     
        e.cellElement.style.cursor= "pointer" ;
      })
  }
}
onCellPrepared2(e) {   
 
  if(e.rowType === "data" && (e.column.dataField === "edit" ) ) {
    e.cellElement.style.color = "blue";     
    e.cellElement.style.cursor= "pointer" ; 
    e.watch(function() {
        return e.data.view;
    }, function() {
      e.cellElement.style.color = "blue";     
      e.cellElement.style.cursor= "pointer" ;
    })
}
}

  constructor( private datePipe: DatePipe,private dsService: DatasourceService,
    private router: Router) { 
    let ps=sessionStorage.getItem('PageSize'); 
     this.PageSize=ps==null?"25":ps;
    let userid=sessionStorage.getItem('userId');   
    
    if(userid==null||userid=="")
    {
      
      this.router.navigate(['']);
    }
    let username=sessionStorage.getItem('userName'); 
    this.username=username==null?"":username;  
      this.input_getdata.BrokerToken=environment.MasterToken;
      this.input_getdata.UserId=userid==null?"":userid;

      
      
  }


  logout()
  {
    
    sessionStorage.clear();
    this.router.navigate(['']);
  }

updateuser()
{
  this.input_updateuser.id=this.usermacid;
  this.input_updateuser.action=this.useractionval;
  this.input_updateuser.state=this.selectedstate;
  //console.log(this.input_updateuser);
  this.dsService.UpdateStateAction(this.input_updateuser).subscribe(result => {
      
    alert('user is updated.'); 
    this.input_updateuser.id=0;
  this.input_updateuser.action=false;
  this.input_updateuser.state=0;    
    this.getUserList();
},
    error => {console.error(error);
      alert('There is some error.Please contact to Admin.');
    }
);

  $("#popup3").hide();
  $(".backdrop3").fadeOut(200);
}



  updateversion()
  {

    this.input_updateversion.token=environment.MasterToken;
    this.input_updateversion.oldversion=this.oldversion;
    this.input_updateversion.newversion=this.newversion;
    
    this.dsService.updateversion(this.input_updateversion).subscribe(result => {
      
      alert('Version is updated.'); 
      this.input_updateversion.oldversion="";
      this.oldversion="";
    this.input_updateversion.newversion="";
    this.newversion="";     
      this.getDataSourceList();
  },
      error => {console.error(error);
        alert('There is some error.Please contact to Admin.');
      }
  );

    $("#popup2").hide();
    $(".backdrop").fadeOut(200);
  }
  saveclosepopup() {   
    
      if(this.brokerName=="")
      {
        alert("You must have a broker name.");
        return false;
      }
      if(this.numberofLicenses==0)
      {
        alert("Number of Licenses must be greater than zero.");
        return false;
      }
      
      if(this.licenseStartdate.toString()=="")
      {
        alert("License must have a Start date.");
        return false;
      }
      /*
      if(this.licenceEnddate.toString()=="")
      {
        alert("License must have a End date.");
        return false;
      }*/
      console.log(this.licenceEnddate);
    if(this.licenceEnddate!=null && this.licenceEnddate!="" && this.licenseStartdate>this.licenceEnddate)
    {
      alert("Start date can not be greater than end date.");
      
      return false;
      
    }
    
    if(this.PopupTittle=="Add Broker")
    {
     
      this.inputSaveData.brokerToken = this.input_getdata.BrokerToken;
    }
    else
    {
     
      this.inputSaveData.brokerToken = this.id_brokerToken;
    }
      this.inputSaveData.brokerName=this.brokerName;     
      this.inputSaveData.numberofLicenses= this.numberofLicenses;
      this.inputSaveData.licenseStartdate= this.licenseStartdate;
      this.inputSaveData.licenceEnddate= this.licenceEnddate;
      this.inputSaveData.brokersStreet= this.brokersStreet;
      this.inputSaveData.number= this.number;
      this.inputSaveData.box= this.box;
      this.inputSaveData.zipcode= this.zipcode;
      this.inputSaveData.location= this.location;
      this.inputSaveData.cbfanr= this.cbfanr;
      this.inputSaveData.userId= this.input_getdata.UserId;
      this.inputSaveData.version= this.version;
      this.inputSaveData.configMode= this.configMode;
      this.addUpdateDatasource(this.inputSaveData);

      $("#popup").hide();
      $(".backdrop").fadeOut(200);

  }
  closepopup2() {
     
    this.oldversion="";
    this.newversion="";

    $("#popup2").hide();
    $(".backdrop2").fadeOut(200);
}
closepopup3() {
     
  this.oldversion="";
  this.newversion="";

  $("#popup3").hide();
  $(".backdrop3").fadeOut(200);
}
myFunction() {
 console.log(1);
  $("#myDropdown").show();
}
  closepopup() {
     
      this.clearFieldValues();

      $("#popup").hide();
      $(".backdrop").fadeOut(200);
  }
  openpopup_updateversion() { 
    console.log(4); 
    $("#myDropdown").hide(); 
      $("#popup2").show();
      $(".backdrop2").fadeTo(200, 1);
  }
  openpopup_add() {
    console.log(2);
    this.brokerToken="";
    this.clearFieldValues();
    this.PopupTittle="Add Broker";
      $("#popup").show();
      $(".backdrop").fadeTo(200, 1);
  }
  openpopup_edit() {   
    console.log(3);
    this.PopupTittle="View / Edit Broker";
    
      $("#popup").show();
      $(".backdrop").fadeTo(200, 1);
  }

  ngOnInit() {
      $("#popup").hide();   
      this.NavCliked(1);  

  }
  OnRowClick(e)
  {   
    this.brokerToken="";
    if(e.displayValue=="Edit/View"){     
      this.brokerName = e.data.brokerName;
      this.brokerToken=e.data.brokerToken;
      this.numberofLicenses= e.data.numberofLicenses;
      this.licenseStartdate= e.data.licenseStartdate;
      this.licenceEnddate= e.data.licenceEnddate;
      this.brokersStreet= e.data.brokersStreet;
      this.number= e.data.number;
      this.box= e.data.box;
      this.zipcode= e.data.zipcode;
      this.location= e.data.location;
      this.cbfanr= e.data.cbfanr;
      this.version= e.data.version;
      this.id_brokerToken=e.data.brokerToken;
      this.configMode=e.data.configMode;
        this.openpopup_edit();
    }   
  }
  OnRowClick2(e)
  {   
    this.usermacid =0;
    this.usernameval="";
      this.macaddressval ="";
      this.useractionval=false;
      this.selectedstate = 0;

    if(e.displayValue=="Edit"){  
      this.usermacid = e.data.id;
      this.usernameval=e.data.userName;
      this.macaddressval = e.data.macaddress;
      this.useractionval=e.data.active;
      this.selectedstate = e.data.state;
        this.openpopup_edit2();
    }   
  }
  changestate(e)
  {
    //console.log(e);
    if(e=="Approved")
    {
      this.selectedstate =1;
    }
    if(e=="Unapproved")
    {
      this.selectedstate =2;
    }
    if(e=="Blocked")
    {
      this.selectedstate =3;
    }
  }
  openpopup_edit2() {   
    console.log(3);
    this.PopupTittle="View / Edit user";
    
      $("#popup3").show();
      $(".backdrop3").fadeTo(200, 1);
  }
  getDataSourceList() {
    this.dsService.getDataSourceList(this.input_getdata)
      .subscribe(result => {
            
            this.listOfData = result.data;
            this.listOfData.forEach(element => {
                  element.edit="Edit/View";
                  
                  element.FullAddress=element.brokersStreet+" "+element.number+"/"+element.box+", "+element.zipcode+"-"+element.location
              });  
          },
          error => console.error(error)
      );
      this.clearFieldValues();
  }
  getUserList() {
    this.dsService.GetAllUserDtails()
      .subscribe(result => {
            
            this.listOfUserData = result.data;
            this.listOfUserData.forEach(element => {
                  element.edit="Edit";
              });  
          },
          error => console.error(error)
      );
      
  }
  NavCliked(e:any)
  {
    if(e==1)
    {
      this.headerflag=false;
      this.headerLabel="Broker list";

      this.getDataSourceList();
    }
    else{
      this.headerflag=true;
      this.headerLabel="User list";
      this.getUserList();
    }
  }

  addUpdateDatasource(input: any) {
    
    this.dsService.addUpdateDatasource(input).subscribe(result => {
      if(this.PopupTittle=="Add Broker")
      {
      alert('Broker is added.');
      }
      else{
        alert('Broker is updated.');
      }
      this.getDataSourceList();
  },
      error => {console.error(error)
        alert('There is some error.Please contact to Admin.');
      }
  );
     
  }
  clearFieldValues()
  {

    let dt=this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.brokerName = "";
      this.brokerToken="";
      this.id_brokerToken="";
      this.numberofLicenses= 0;
      this.licenseStartdate=dt!=null?dt:""
      this.licenceEnddate= dt!=null?dt:""
      this.brokersStreet= "";
      this.number= "";
      this.box= "";
      this.zipcode= 0;
      this.location= "";
      this.cbfanr= "";
      this.PopupTittle="";
      this.version="";
  }

}
